import { UpdateEmbeddedSpaceMutation, UpdateEmbeddedSpaceMutationVariables } from 'generated/graphql'
import gql from 'graphql-tag'
import graphql from 'utils/graphql'

const updateEmbeddedSpaceMutation = gql`
    mutation updateEmbeddedSpace($id: Int!, $data: UpdateEmbeddedSpaceInput!) {
        updateEmbeddedSpace(embeddedSpace: $id, data: $data) {
            id
        }
    }
`
export const updateEmbeddedSpace = (id, data) => {
    const mutation = graphql.createQuery<
        UpdateEmbeddedSpaceMutation, UpdateEmbeddedSpaceMutationVariables
    >(updateEmbeddedSpaceMutation)

    return mutation({ id, data })
}
